// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*::-webkit-scrollbar {
  width: 0 !important;
}

:host {
  display: block;
  width: 100%;
  height: 100%;
}

.card,
.card.bradius {
  width: 100% !important;
  padding-bottom: 0 !important;
  background-color: #fff !important; /* Blanco */
  border: none !important;
  min-height: 621px !important;
  height: 100% !important;
  box-shadow: none !important;
  border-radius: 24px !important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;   /* reducido de 20px: menos espacio entre imagen y nombre */
}

.card:hover {
  cursor: grab;
}

.form-control {
  border: none;
  color: black;
  background-color: rgb(251, 230, 201);
}

.card .containerImg {
  width: 100%;
  height: auto !important; /* Allow aspect ratio to control height proportionally */
  aspect-ratio: 384 / 241.8 !important;
  flex-shrink: 0 !important; /* Prevent flexbox from squishing the image */
  overflow: hidden;
  border-radius: 24px 24px 0 0;
  -webkit-border-radius: 24px 24px 0 0;
  -moz-border-radius: 24px 24px 0 0;
  -ms-border-radius: 24px 24px 0 0;
  -o-border-radius: 24px 24px 0 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.card .containerImg p {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #f09502c4;
  color: white;
  border: 1px solid white;
  padding: 4px 10px;
  border-radius: 7px 0 7px 0;
  -webkit-border-radius: 7px 0 7px 0;
  -moz-border-radius: 7px 0 7px 0;
  -ms-border-radius: 7px 0 7px 0;
  -o-border-radius: 7px 0 7px 0;
}

.card .title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 2%;
}

.card .title > img {
  width: 32%;
  height: auto;
  margin-right: 25px;
}

.card .title > div {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-wrap: wrap;
}

.card .title > div p {
  width: 100%;
  margin-bottom: 0;
}

.card .title > div p:first-child {
  margin-bottom: 10px;
  font-size: 1rem;
}

.card .title .estado {
  color: white;
  padding: 3px 15px;
  width: auto !important;
}

.card-body .pdata {
  width: 100%;
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.card-body .pdata > div {
  width: 50%;
}

.card-body .pdata > div:last-child {
  text-align: right;
}

/* Modificamos card-body para que utilice flex y respete el gap de 20px también en su interior */
.card-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px; /* Asegurar 20px de gap en la parte superior respecto a la imagen */
  flex: 1;
}

/* Estilos para "Gestionando Inversiones" */
.status-container {
  position: relative;
}

.gestionando-inversiones {
  display: block;
  margin-top: 5px; /* Ajusta la distancia entre "Activo" y "Gestionando Inversiones" */
  color: #848484;
  font-size: 12.6px;
  text-align: center;
}

.pdatas {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
}

.dataTransferencia {
  background: #ededed;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  padding: 0px 0px 50px 40px;
}

.pdata1,
.pdata2,
.pdata3 {
  width: 33%;
  display: flex !important;
  justify-content: center;
  align-items: space-around;
  flex-wrap: wrap;
  padding: 4px;
  text-align: center;
}

.pdata1,
.pdata2 {
  border-right: 1px solid gray;
}

.pdata1 {
  padding-left: 0;
}

.pdata3 {
  padding-right: 0;
}

.modalDetail1 .modal-content1 {
  background-color: #181b25;
}

.modalDetail1 .modal-content1 > * {
  width: 80%;
  margin: 0 auto;
}

.modal-header {
  border-bottom: 2px solid #f09502;
}

.card .containerButtons {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  align-items: stretch;
  margin-top: 12px; /* 20px (del gap) + 12px = 32px exactos */
  margin-bottom: 0; /* Quitar el auto margin para respetar los gaps exactos */
}

.card .containerButtons button {
  width: 48%;
  margin-bottom: 0 !important;
}

/* Cuando el botón tiene la clase w-100, asegurarse que ocupe todo el ancho */
.card .containerButtons button.w-100 {
  width: 100% !important;
}

.buyform {
  margin: 10px 10px 35px 80px;
}

.buyform .cost {
  background-color: #0d0d0d;
  padding: 15px;
  font-size: 1rem;
}

.buyform button {
  min-width: 60%;
  background-color: #0d0d0e !important;
  color: white;
}

.dataSale {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  flex-wrap: wrap;
}

.dataSale > div {
  border: 1px solid #f09502;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dataSale .logoPolyscan {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid;
  padding: 8px;
  margin-right: auto;
  min-width: 70%;
}

.dataSale .logoPolyscan:hover {
  cursor: pointer;
}

.dataSale .logoPolyscan img {
  max-width: 40px;
  height: auto;
  margin-right: 5px;
}

.dataSale .email {
  min-width: 70%;
}

.dataSale > div:first-child {
  width: 40%;
}

.dataSale > div span {
  font-weight: bold;
  font-size: 1rem;
}

.dataSale > div:last-child {
  width: 59%;
}

.dataSale .title {
  font-size: 1.3rem;
  margin-bottom: 18px;
  font-weight: bold;
  color: #f09502;
}

.dataSale > div:first-child p:last-child {
  margin-bottom: 0 !important;
}

.dataSale a {
  display: flex;
  justify-content: center;
  width: 100%;
  text-decoration: none;
}

.dataDisplay {
  display: flex;
  gap: 60px;
  margin-top: 2rem;
}


@media (max-width: 1400px) {
  .navMargin {
    margin-top: 3rem !important;
  }

  .cardContainer {
    margin-top: 1rem !important;
  }

  .sizeTitle {
    font-size: 15px !important;
  }
}

@media (max-width: 1235px) {
  .popularBlockchain {
    padding: 0 !important;
    top: -40px !important;
    left: calc(50% - 60px) !important;
  }
}

@media (max-width: 995px) {
  .popularBlockchain {
    padding: 2px 10px 0px 10px !important;
    top: -22px !important;
    left: calc(50% - 68px) !important;
  }

  .infoCardModal {
    display: none !important;
  }

  .cardImageModal {
    border: none !important;
    padding: 10px 15px 10px 15px;
    background-color: transparent !important;
  }

  .cardImageContainerModal {
    border-radius: 0px !important;
  }
}

@media (max-width: 820px) {
  .popularBlockchain {
    padding: 0 !important;
    left: calc(50% - 60px) !important;
  }
}

@media (max-width: 720px) {
  .popularBlockchain {
    top: -40px !important;
  }
}

@media (max-width: 656px) {
  .buyform {
    margin: 20px !important;
    margin-left: calc(15% - 30px) !important;
  }

  .cardContainer {
    margin-top: 2rem !important;
    padding-left: 10px !important;
    padding-right: 0 !important;
    margin-bottom: 2rem !important;
  }

  .circle {
    display: none;
  }

  .modalDetail .modal-content > *,
  .modalDetail2 .modal-content > * {
    width: 103%;
  }

  .buyform button {
    width: 100%;
  }

  .pdata1,
  .pdata2,
  .pdata3 {
    padding: 5px;
  }

  .pdata1 p:first-child,
  .pdata2 p:first-child,
  .pdata3 p:first-child {
    font-size: 0.7rem;
  }

  .dataSale > div:first-child {
    width: 100%;
    padding: 0 !important;
    margin-bottom: 35px;
    padding-bottom: 35px !important;
    border-bottom: 1px solid #8282828f !important;
  }

  .dataSale > div:last-child {
    width: 100%;
    padding: 0 !important;
    border: none;
  }

  .priceData {
    flex-direction: column;
    margin: 2rem !important;
  }

  .containerBox {
    flex-direction: column;
    /*gap: 20px;*/
  }

  .specialBox {
    margin-top: 1rem !important;
  }

  .titulo-movil {
    font-size: 1rem !important;
    margin-top: 1rem;
  }

  .movil-nav {
    margin-top: -2rem !important;
  }

  .movil-options {
    margin-top: -1rem !important;
  }

  .nav {
    display: flex;
    flex-direction: column;
  }

  .navMargin {
    margin: 0 !important;
  }

  .dataTransferencia {
    padding: 0px 0px 50px 20px;
  }

  .box {
    flex-basis: 100% !important;
    /* Las cajas ocuparán todo el ancho en pantallas más pequeñas */
    max-width: 100% !important;
    /* Límite de ancho máximo de las cajas */
  }

  .terms {
    margin-left: 0 !important;
  }

  .buttonflex {
    margin-left: 0 !important;
  }

  .marginCantitad {
    margin-left: 0 !important;
  }

  .popularBlockchain {
    padding: 2px 10px 0px 10px !important;
    top: -22px !important;
    left: calc(50% - 68px) !important;
  }

  select {
    margin-bottom: 10px;
  }

  .dataTransferencia {
    padding: 0px 0px 50px 5px;
  }

  .iban {
    padding-top: 23px;
  }

  .dataDisplay {
    gap: 20px;
  }

  .form-control {
    font-size: 11px;
  }

  .cardImageContainerModal {
    width: 100%;
    padding-bottom: 0 !important;
    background-color: #ffffff !important; /* Blanco */
    border: 1px solid #e0e0e0 !important; /* Borde delgado gris */
    margin-bottom: 30px;
    border-radius: 18px !important; /* Bordes más redondeados */
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important; /* Sombra ligera */
  }

  .no-mobile {
    display: none !important;
  }

  h5 {
    font-size: 0.85rem !important;
  }

  .popular {
    left: calc(50% - 50px) !important;
  }
}

@media (min-width: 656px) {
  .options-mobile {
    display: none;
  }
}

.flexContainer {
  display: flex;
}

.colorDark {
  background-color: #181b25;
}

.colorWhite {
  background-color: white;
}

.paddingModalBody {
  padding: 0 !important;
}

.cardContainer {
  margin-top: 4rem;
  padding-left: 3rem;
  padding-right: 3rem;
}

.btnClose {
  background-color: transparent;
  color: white;
  border: none;
  font-size: 15px;
}

.btnContainer {
  margin-top: 2rem;
}

mdb-tab {
  color: black !important;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #ff9600;
  border: none;
  border-bottom: 1px solid;
}

.nav-link {
  color: black;
  border: none;
  font-weight: bold;
  cursor: pointer;
}

.dai {
  display: flex;
  align-items: center;
  gap: 5px;
}

.iQuestion {
  color: gray;
  font-size: 24px;
  margin-top: -4px;
}

p,
label {
  color: #848484;
}

.marginCantitad {
  display: flex;
  gap: 15px;
  margin-left: -2.3rem;
}

.priceData {
  display: flex;
  justify-content: space-between;
  margin: 10px 120px 10px 85px;
}

.containerBox {
  display: flex;
  flex-wrap: wrap;
  /* Permite que los elementos se envuelvan cuando no haya suficiente espacio en una línea */
}

.box {
  border: 3px solid #ff9600;
  padding: 5px 5px 5px 5px;
  margin-right: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  border-radius: 20px;
  max-width: 250px;
  position: relative;
  flex: 1;
}

.box.active {
  background-color: rgba(255, 150, 0, 0.2);
}

.popular {
  position: absolute;
  border: 3px solid #ff9600;
  background: white;
  border-radius: 25px;
  padding: 2px 10px 0px 10px;
  top: -24px;
  left: calc(50% - 68px);
}

.divPersonalizar {
  display: flex;
  align-items: center;
}

.personalizar {
  color: black;
  text-decoration: underline;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.form-control:focus {
  outline-color: #ff9600;
}

.navMargin {
  margin: 70px 10px 30px 80px;
  margin-top: 7rem;
}

.tool {
  cursor: help;
  position: relative;
}

.tool::before,
.tool::after {
  top: 50%;
  opacity: 0;
  position: absolute;
  z-index: -100;
}

.tool:hover::before,
.tool:focus::before,
.tool:hover::after,
.tool:focus::after {
  opacity: 1;
  transform: scale(1) translateX(0);
  z-index: 100;
  margin-left: 1rem;
}

.tool:hover::before,
.tool:focus::before {
  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26) 0.2s;
}

.tool::after {
  background: #3e474f;
  border-radius: 0.25em;
  color: #edeff0;
  content: attr(data-tip);
  margin-top: -2.5em;
  padding: 1em;
  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26) 0.2s;
  transform: scale(0.6) translateX(50%);
  width: 20em;
}

.tool:hover::after,
.tool:focus::after {
  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26);
}

@media (max-width: 1060px) {
  .tool::after {
    font-size: 0.95em;
    margin-top: -15.5em;
    width: 28em;
    right: 27%;
    margin-top: -2px;
    transform: translate(-50%, -50%);
  }
}

@media (max-width: 760px) {
  .tool::after {
    font-size: 0.75em;
  }
}

/*tooltip Box*/
.con-tooltip {
  position: relative;
  display: inline-block;
  cursor: help;
}

/*tooltip */
.tooltip {
  visibility: hidden;
  z-index: 1;
  position: absolute;
  top: -140%;
  left: -25%;
  background: #3e474f;
  border-radius: 0.25em;
  color: #edeff0;
  padding: 1em;
  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26) 0.2s;
  transform: scale(0.6) translateX(50%);
  width: 20em;
}

.con-tooltip:hover .tooltip {
  visibility: visible;
  transform: translateY(-10px);
  opacity: 1;
}

.right .tooltip {
  top: 150%;
  left: -800%;
}

.right .tooltip::after {
  top: 150%;
  left: -800%;
  transform: rotate(90deg);
}

.card {
  position: relative;
  border-radius: 24px; /* Cambiado a 24px según Figma general */
  width: 100%;
  margin: 0 auto; /* Centrar dentro del col-lg-4 */
}

/* --- Botón Favoritos (Corazón) --- */
.favorite-btn {
  position: absolute;
  top: 26px;
  right: 26px;
  display: flex !important;
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
  justify-content: center !important;
  align-items: center !important;
  border-radius: 50% !important;
  border: 1px solid rgba(255, 193, 91, 0.25) !important;
  background: #FFF !important;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.40) !important;
  cursor: pointer;
  z-index: 10;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.favorite-btn i {
  color: #ff8c00; /* Naranja Domoblock */
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  line-height: 1 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transform: none;
  transition:
    transform 0.2s ease,
    color 0.2s ease;
}

/* Hover effect */
.favorite-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.favorite-btn:hover i {
  transform: scale(1.1);
}

/* Estado activo (cuando ya es favorito) */
.favorite-btn.is-active i {
  color: #ff8c00;
}
/* --------------------------------- */
.circle {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  background: #292929;
  color: white;
}

.terms {
  display: flex;
  gap: 10px;
  margin-left: -2.2rem;
}

.buttonflex {
  display: flex;
  gap: 10px;
  margin-left: -2.2rem;
  margin-top: 1rem;
  align-items: center;
}

.popularBlockchain {
  position: absolute;
  border: 3px solid #ff9600;
  background: white;
  border-radius: 25px;
  padding: 2px 10px 0px 10px;
  top: -22px;
  left: calc(50% - 68px);
}

.sizeTitle {
  font-weight: 600;
}

select {
  border: 1px solid white !important;
}

@media screen and (max-width: 600px) {
  #amountBuyTransferencia::placeholder {
    font-size: 9px;
  }
}

.header-modal-wallet {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #ff9600;
  font-size: 19px;
  color: white;
  border-radius: 50px;
  padding: 8px;
}

/* Ocultar la wallet completa en dispositivos móviles */
@media (max-width: 768px) {
  .full-wallet {
    display: none;
  }
  .short-wallet {
    display: inline;
  }
  .header-modal-wallet {
    font-size: 13px;
  }
}

/* Mostrar la wallet completa en dispositivos de escritorio */
@media (min-width: 769px) {
  .full-wallet {
    display: inline;
  }
  .short-wallet {
    display: none;
  }
}

@media (max-width: 1450px) and (min-width: 500px) {
  .small-text {
    font-size: 0.85rem !important; /* Ajusta el tamaño según tus necesidades */
  }
}

.progress {
  height: 18px; /* Un poco más de altura para que el texto respire */
  border-radius: 20px;
  background-color: #e2e2e2;
  box-shadow: none;
  overflow: hidden; /* Asegura que la barra verde no se salga por las esquinas */
}

.progress-bar {
  background: linear-gradient(90deg, #56a652 0%, #7ebc8c 100%) !important;
  border-radius: 20px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important; /* Centrar el texto en la parte verde */
  font-size: 11px;
  font-weight: 700;
  color: white;
  white-space: nowrap; /* Evitar saltos de línea */
}

/* Nuevos estilos para el diseño actualizado de la tarjeta (layout anibaldev) */
.project-header {
  width: 100%;
}

.project-title {
  font-size: 19px !important; /* Adjusted slightly to fit the Hug dimension */
  font-weight: 600 !important;
  color: #000 !important;
  margin: 0 0 10px 0 !important;
  line-height: 23px !important;
  width: 100% !important;
  word-break: break-word;
}

.card .card-body .project-title,
.card .project-header .project-title,
.card .project-header h2.project-title,
.card-body .project-header h2.project-title {
  font-size: 19px !important;
  font-weight: 600 !important;
  line-height: 23px !important;
}

.project-address {
  font-size: 0.95rem;
  color: #000;
  margin: 0;
  line-height: 1.3 !important;
  align-items: center !important;
  min-width: 0;
  flex-wrap: nowrap;
}

.project-address span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1;
}

.project-address .fa-map-marker-alt {
  margin-top: 0;
  flex-shrink: 0;
}

.project-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.badge-pill {
  display: flex !important;
  padding: 4px 8px !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 10px !important;
  border-radius: 30px !important;
  font-size: 10px !important;
  line-height: 12px !important;
  font-weight: 500 !important;
  white-space: nowrap !important;
}

.badge-type {
  background: #cdffd8;
  color: #3b8c4c; /* Color verde oscuro sugerido para contraste */
}

.badge-code {
  background-color: #000;
  color: #fff;
}

.pdata-new {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end; /* Alinea los bloques por abajo */
  margin-bottom: 8px; /* Un poco más pegado a la barra de progreso */
  padding: 0 5px; /* Añade aire a los lados para que no estén pegados a los bordes */
}

.pdata-new > div {
  display: flex;
  flex-direction: column;
}

.pdata-new > .text-right {
  align-items: flex-end; /* Fuerza los elementos hijos a alinearse a la derecha */
}

.finance-label {
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px; /* Aumentado tamaño */
  color: #000000 !important;
  margin: 0 0 2px 0; /* Menos espacio entre la etiqueta y el monto */
  font-weight: 400 !important; /* Regular */
  height: 15px !important;
  line-height: 15px !important;
}

.finance-amount {
  font-family: 'Montserrat', sans-serif !important;
  font-size: 15px; /* Aumentado tamaño para dar mayor jerarquía */
  font-weight: 600 !important; /* Semibold */
  color: #000000 !important;
  margin: 0;
  height: 15px !important;
  line-height: 15px !important;
}

.project-details {
  width: 100%;
}

.detail-item {
  font-size: 0.95rem;
  color: #000;
  margin: 0 0 8px 0; /* Reduce this margin if you want them tighter */
  height: 16px !important;
  line-height: 16px !important;
  display: flex;
  align-items: center;
  gap: 4px;
}

.detail-value {
  font-weight: bold;
  height: 15px !important;
  line-height: 15px !important;
  display: inline-flex;
  align-items: center;
}

.detail-item-private {
  color: #B0B0B0 !important;
  font-family: 'Montserrat', sans-serif !important;
  font-size: 0.95rem !important;
  font-weight: 400 !important;
  font-style: normal !important;
  height: auto !important;
  white-space: nowrap;
  flex-wrap: nowrap;
}

.detail-item-private .private-label {
  display: inline-flex;
  align-items: center;
}

.detail-item-private .private-trailing {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.detail-item-private .badge-private-return,
.detail-item-private .private-info-icon {
  flex-shrink: 0;
}

@media (max-width: 600px) {
  .detail-item-private {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: 6px;
    padding-right: 4px;
    font-size: 0.8rem !important;
    white-space: nowrap;
  }

  .project-address {
    font-size: 0.8rem !important;
    min-width: 0;
    align-items: center !important;
  }

  .project-address span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    flex: 1;
  }

  .project-address .fa-map-marker-alt {
    margin-top: 0;
    font-size: 0.9rem;
    line-height: 1;
  }
}

.badge-private-return {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #FFC15B40;
  color: #D79C40;
  padding: 2px 10px;
  border-radius: 12px;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: normal;
}

.badge-private-return .bi {
  color: #D79C40;
  font-size: 12px;
  line-height: 1;
}

.badge-private-number {
  display: inline-block;
  width: 31px;
  height: 12px;
  color: #D79C40 !important;
  text-align: center;
  font-family: 'Montserrat', sans-serif !important;
  font-size: 10px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: normal !important;
  white-space: nowrap;
}

.private-info-icon {
  color: #D79C40;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

/* Badge de estado en la imagen */
.status-badge {
  position: absolute;
  top: 26px;
  left: 26px;
  display: inline-flex !important;
  width: auto !important;
  min-width: 90px !important;
  max-width: calc(100% - 52px) !important;
  height: 31px !important;
  box-sizing: border-box !important;
  padding: 8px 14px !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 10px !important;
  border-radius: 30px !important;
  color: #FFF !important;
  text-align: center !important;
  font-family: Montserrat, sans-serif !important;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: normal !important;
  white-space: nowrap !important;
  z-index: 10;
}

.badge-venta-privada,
.badge-abierto {
  background-color: #67B563 !important;
}

.badge-en-estudio {
  background-color: #F25783 !important;
}

.badge-gestionando {
  background-color: #67B563 !important;
}

.badge-activo {
  background-color: #67B563 !important;
}

.badge-financiado {
  background-color: #B084E9 !important;
}

.badge-en-curso {
  background-color: #B084E9 !important;
}

.badge-dividendos {
  background-color: #579AF2 !important;
}

.badge-vendido {
  background-color: #AEB4BD !important;
}

/* --- Contador de lanzamiento (proyectos "En estudio") --- */
.launch-countdown {
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  box-sizing: border-box;
  width: max-content;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 16px;
  padding: 6px 18px 10px 18px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.12); /* #0000001F */
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.12);
  font-family: Montserrat, sans-serif;
}

.countdown-unit {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 52px;
}

.countdown-value {
  color: #fff;
  font-size: 39px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

.countdown-label {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}

.countdown-divider {
  width: 1px;
  height: 45px;
  align-self: center;
  background: rgba(255, 255, 255, 0.6);
}

.btn-invest {
  background: #ff9600;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 8px 24px !important;
  font-weight: 700;
  font-size: 15px !important;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;
  
  /* Nuevas medidas de Figma */
  display: flex !important;
  width: 142px !important;
  height: 34px !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 10px !important;
  flex-shrink: 0 !important;
  box-sizing: border-box !important;
  white-space: nowrap !important;
}

.btn-invest:hover:not(:disabled) {
  background: #e68700;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 150, 0, 0.3);
}

.btn-invest:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-know-more {
  background: white;
  color: #ff9600;
  border: 1px solid #ff9600;
  border-radius: 10px;
  padding: 8px 20px !important;
  font-weight: 700;
  font-size: 15px !important;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05); /* Sombra suavizada */
  transition: all 0.3s ease;

  /* Nuevas medidas de Figma */
  display: flex !important;
  width: 142px !important;
  height: 34px !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 10px !important;
  flex-shrink: 0 !important;
  box-sizing: border-box !important;
  white-space: nowrap !important;
}

.btn-know-more:hover:not(:disabled) {
  background: #fff8f0;
  color: #e68700;
  border-color: #e68700;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-know-more:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.card .containerButtons {
  display: flex;
  gap: 12px;
  width: 100%;
  flex-wrap: wrap;
}

.card .containerButtons .btn {
  flex: 1;
  margin-bottom: 0 !important;
  min-width: 0;
}

.card .containerButtons .btn.w-100 {
  flex: 1 1 100%;
}

/* =========================================================================
   Ajustes Figma escritorio 1440 (franja 992px–1440px).
   - >1440px: se mantiene el diseño original (card fluida, como estaba antes).
   - 992–1440px: medidas exactas de Figma. El cap max-width:327 hace que el
     ancho se ajuste de forma responsive según baja el viewport.
   - <992px: responsive original de tablet/móvil.
   ========================================================================= */
@media (min-width: 992px) and (max-width: 1440px) {
  /* Tarjeta: 327x580 fija, centrada en su columna */
  .card,
  .card.bradius {
    max-width: 327px !important; /* ancho de tarjeta */
    margin-left: auto !important;
    margin-right: auto !important;
    height: 580px !important; /* alto fijo */
    min-height: 580px !important;
    max-height: 580px !important;
    align-self: flex-start !important; /* evita que el stretch del row la alargue */
    gap: 8px; /* reduce hueco imagen<->título para que el contenido suba */
  }

  /* Imagen ocupa todo el ancho de la tarjeta */
  .card .containerImg {
    width: 100% !important;
    align-self: stretch !important;
  }

  /* Reduce padding sup/inf para que "Ver detalles" no se corte en los 580px */
  .card-body {
    padding: 4px 20px 12px 20px;
  }

  /* Badge "En estudio": 90x31 con padding 8/12 */
  .badge-en-estudio {
    width: 90px !important;
    min-width: 90px !important;
    max-width: 90px !important;
    height: 31px !important;
    padding: 8px 12px !important;
  }

  /* Countdown: número 53x35.52, etiquetas alto 15 con anchos por palabra */
  .countdown-unit {
    width: 53px;
  }

  .countdown-value {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 53px;
    height: 35.52px;
    font-size: 35.52px; /* line-height:1 -> caja de texto = 35.52px */
  }

  .countdown-label {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 15px;
    font-size: 15px;
  }

  .countdown-label--dia {
    width: 47px;
  }

  .countdown-label--hora {
    width: 50px;
  }

  .countdown-label--minuto {
    width: 50px;
  }

  /* Título 192x23 (alto ya viene de line-height:23) */
  .project-title {
    width: 192px !important;
  }

  /* Dirección 211x17 */
  .project-address {
    width: 211px;
    height: 17px;
    line-height: 17px !important;
  }

  /* Icono de dirección 10.3x12.6 (inline-block para que apliquen width/height) */
  .project-address .fa-map-marker-alt {
    display: inline-block;
    width: 10.3px;
    height: 12.6px;
    font-size: 12.6px;
  }

  /* Badges: se mantiene el estilo base (hug + padding 4px 8px = Figma).
     Solo aumentamos la separación entre las dos badges a 20px. */
  .project-badges {
    gap: 20px;
  }

  /* Financiado/Objetivo: etiquetas y valores 116.8x15 (alto ya viene de line-height:15) */
  .finance-label,
  .finance-amount {
    width: 116.8px;
  }

  /* Columna Objetivo: alinear texto a la derecha dentro de su caja de 116.8px */
  .text-right .finance-label,
  .text-right .finance-amount {
    text-align: right;
  }

  /* Barra de progreso 238.9x14 */
  .progress {
    width: 238.9px;
    height: 14px;
  }

  /* Rentabilidad Venta Privada: evitar que el icono "i" (tooltip) se corte.
     Se reduce un poco la fuente de esta fila para que la etiqueta entre
     completa (sin …) y el badge + icono queden dentro de la tarjeta (327px). */
  .detail-item-private {
    font-size: 0.9rem !important; /* casi igual que las demás filas (0.95rem) */
    gap: 2px; /* reduce el espacio después del ":" */
  }

  /* Badge un poco más compacto para liberar espacio a la derecha */
  .detail-item-private .private-trailing {
    gap: 4px;
  }

  .detail-item-private .badge-private-return {
    padding: 2px 6px;
    gap: 3px;
  }

  /* La etiqueta se ajusta a su texto (no crece): así el badge queda pegado al ":" */
  .detail-item-private .private-label {
    display: block;
    flex: 0 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis; /* fallback por si el texto fuese más largo */
    white-space: nowrap;
  }
}

/* =========================================================================
   Ajustes mobile (<992px)
   ========================================================================= */
@media (max-width: 991.98px) {
  /* Tarjeta mobile: frame Figma 384x621. El alto 621 ya viene de min-height
     en la base; aquí acotamos el ancho a 384px (max-width para que en
     pantallas más angostas se ajuste) y la centramos. */
  .card,
  .card.bradius {
    max-width: 384px !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  /* Countdown: alto del número 35.52px (line-height:1 -> caja = font-size) */
  .countdown-value {
    font-size: 35.52px;
  }

  /* Badge "En estudio" según Figma: texto 16px/600 + padding 8px 12px.
     El "88x20" de Figma es el frame del TEXTO; la badge = texto + padding,
     por eso se ajusta al contenido (width/height auto) para que el texto
     entre con su espaciado correcto (queda ~112x36). */
  .badge-en-estudio {
    width: auto !important;
    min-width: 0 !important;
    max-width: none !important;
    height: auto !important;
    padding: 8px 12px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: normal !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/card-real-estate/card-real-estate.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,4BAA4B;EAC5B,iCAAiC,EAAE,WAAW;EAC9C,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ,IAAI,0DAA0D;AACxE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,uBAAuB,EAAE,wDAAwD;EACjF,oCAAoC;EACpC,yBAAyB,EAAE,6CAA6C;EACxE,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;EAC/B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gGAAgG;AAChG;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa,EAAE,mEAAmE;EAClF,OAAO;AACT;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe,EAAE,mEAAmE;EACpF,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;EAGE,UAAU;EACV,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,gBAAgB,EAAE,yCAAyC;EAC3D,gBAAgB,EAAE,yDAAyD;AAC7E;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA,6EAA6E;AAC7E;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;;AAGA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,qBAAqB;IACrB,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,wCAAwC;EAC1C;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,YAAY;EACd;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,+BAA+B;IAC/B,6CAA6C;EAC/C;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,+DAA+D;IAC/D,0BAA0B;IAC1B,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,oCAAoC,EAAE,WAAW;IACjD,oCAAoC,EAAE,uBAAuB;IAC7D,mBAAmB;IACnB,8BAA8B,EAAE,2BAA2B;IAC3D,oDAAoD,EAAE,kBAAkB;EAC1E;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,0FAA0F;AAC5F;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;;EAIE,UAAU;EACV,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,gEAAgE;EAChE,qCAAqC;EACrC,WAAW;AACb;;AAEA;;EAEE,2DAA2D;AAC7D;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,gEAAgE;EAChE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB,EAAE,wCAAwC;EAC7D,WAAW;EACX,cAAc,EAAE,gCAAgC;AAClD;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;EAC7B,qDAAqD;EACrD,2BAA2B;EAC3B,qDAAqD;EACrD,eAAe;EACf,WAAW;EACX;;wBAEsB;AACxB;;AAEA;EACE,cAAc,EAAE,sBAAsB;EACtC,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf;;mBAEiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,cAAc;AAChB;AACA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA,uDAAuD;AACvD;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,6BAA6B,EAAE,2CAA2C;EAC5E;AACF;;AAEA;EACE,YAAY,EAAE,oDAAoD;EAClE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB,EAAE,4DAA4D;AAChF;;AAEA;EACE,uEAAuE;EACvE,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC,EAAE,uCAAuC;EAC3E,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB,EAAE,2BAA2B;AAClD;;AAEA,+EAA+E;AAC/E;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B,EAAE,+CAA+C;EAC3E,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;;;EAIE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;EAC9B,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc,EAAE,+CAA+C;AACjE;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,qBAAqB,EAAE,iCAAiC;EACxD,kBAAkB,EAAE,8CAA8C;EAClE,cAAc,EAAE,kEAAkE;AACpF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB,EAAE,wDAAwD;AACjF;;AAEA;EACE,gDAAgD;EAChD,eAAe,EAAE,qBAAqB;EACtC,yBAAyB;EACzB,iBAAiB,EAAE,+CAA+C;EAClE,2BAA2B,EAAE,YAAY;EACzC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,gDAAgD;EAChD,eAAe,EAAE,8CAA8C;EAC/D,2BAA2B,EAAE,aAAa;EAC1C,yBAAyB;EACzB,SAAS;EACT,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB,EAAE,gDAAgD;EACnE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;EAChD,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;IACR,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,OAAO;EACT;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;EAChD,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,sBAAsB;EACtB,0BAA0B;EAC1B,uCAAuC;EACvC,uBAAuB;EACvB,iCAAiC;EACjC,4BAA4B;EAC5B,kCAAkC;EAClC,8BAA8B;EAC9B,oBAAoB;EACpB,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,8CAA8C;EAC9C,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,+BAA+B,EAAE,cAAc;EAC/C,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;EAC1B,0CAA0C;EAC1C,yBAAyB;;EAEzB,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,8BAA8B;EAC9B,oBAAoB;EACpB,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;EAC1B,2CAA2C,EAAE,qBAAqB;EAClE,yBAAyB;;EAEzB,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,8BAA8B;EAC9B,oBAAoB;EACpB,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;8EAM8E;AAC9E;EACE,kDAAkD;EAClD;;IAEE,2BAA2B,EAAE,qBAAqB;IAClD,4BAA4B;IAC5B,6BAA6B;IAC7B,wBAAwB,EAAE,cAAc;IACxC,4BAA4B;IAC5B,4BAA4B;IAC5B,iCAAiC,EAAE,4CAA4C;IAC/E,QAAQ,EAAE,4DAA4D;EACxE;;EAEA,6CAA6C;EAC7C;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA,4EAA4E;EAC5E;IACE,2BAA2B;EAC7B;;EAEA,+CAA+C;EAC/C;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA,yEAAyE;EACzE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,kBAAkB,EAAE,6CAA6C;EACnE;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA,oDAAoD;EACpD;IACE,uBAAuB;EACzB;;EAEA,qBAAqB;EACrB;IACE,YAAY;IACZ,YAAY;IACZ,4BAA4B;EAC9B;;EAEA,+EAA+E;EAC/E;IACE,qBAAqB;IACrB,aAAa;IACb,cAAc;IACd,iBAAiB;EACnB;;EAEA;iEAC+D;EAC/D;IACE,SAAS;EACX;;EAEA,wFAAwF;EACxF;;IAEE,cAAc;EAChB;;EAEA,8EAA8E;EAC9E;;IAEE,iBAAiB;EACnB;;EAEA,+BAA+B;EAC/B;IACE,cAAc;IACd,YAAY;EACd;;EAEA;;+EAE6E;EAC7E;IACE,4BAA4B,EAAE,6CAA6C;IAC3E,QAAQ,EAAE,sCAAsC;EAClD;;EAEA,iEAAiE;EACjE;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA,kFAAkF;EAClF;IACE,cAAc;IACd,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB,EAAE,6CAA6C;IACtE,mBAAmB;EACrB;AACF;;AAEA;;8EAE8E;AAC9E;EACE;;wDAEsD;EACtD;;IAEE,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA,2EAA2E;EAC3E;IACE,kBAAkB;EACpB;;EAEA;;;uDAGqD;EACrD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;EAChC;AACF","sourcesContent":["*::-webkit-scrollbar {\n  width: 0 !important;\n}\n\n:host {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.card,\n.card.bradius {\n  width: 100% !important;\n  padding-bottom: 0 !important;\n  background-color: #fff !important; /* Blanco */\n  border: none !important;\n  min-height: 621px !important;\n  height: 100% !important;\n  box-shadow: none !important;\n  border-radius: 24px !important;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;   /* reducido de 20px: menos espacio entre imagen y nombre */\n}\n\n.card:hover {\n  cursor: grab;\n}\n\n.form-control {\n  border: none;\n  color: black;\n  background-color: rgb(251, 230, 201);\n}\n\n.card .containerImg {\n  width: 100%;\n  height: auto !important; /* Allow aspect ratio to control height proportionally */\n  aspect-ratio: 384 / 241.8 !important;\n  flex-shrink: 0 !important; /* Prevent flexbox from squishing the image */\n  overflow: hidden;\n  border-radius: 24px 24px 0 0;\n  -webkit-border-radius: 24px 24px 0 0;\n  -moz-border-radius: 24px 24px 0 0;\n  -ms-border-radius: 24px 24px 0 0;\n  -o-border-radius: 24px 24px 0 0;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: relative;\n}\n\n.card .containerImg p {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #f09502c4;\n  color: white;\n  border: 1px solid white;\n  padding: 4px 10px;\n  border-radius: 7px 0 7px 0;\n  -webkit-border-radius: 7px 0 7px 0;\n  -moz-border-radius: 7px 0 7px 0;\n  -ms-border-radius: 7px 0 7px 0;\n  -o-border-radius: 7px 0 7px 0;\n}\n\n.card .title {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 2%;\n}\n\n.card .title > img {\n  width: 32%;\n  height: auto;\n  margin-right: 25px;\n}\n\n.card .title > div {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  flex-wrap: wrap;\n}\n\n.card .title > div p {\n  width: 100%;\n  margin-bottom: 0;\n}\n\n.card .title > div p:first-child {\n  margin-bottom: 10px;\n  font-size: 1rem;\n}\n\n.card .title .estado {\n  color: white;\n  padding: 3px 15px;\n  width: auto !important;\n}\n\n.card-body .pdata {\n  width: 100%;\n  display: flex !important;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.card-body .pdata > div {\n  width: 50%;\n}\n\n.card-body .pdata > div:last-child {\n  text-align: right;\n}\n\n/* Modificamos card-body para que utilice flex y respete el gap de 20px también en su interior */\n.card-body {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px; /* Asegurar 20px de gap en la parte superior respecto a la imagen */\n  flex: 1;\n}\n\n/* Estilos para \"Gestionando Inversiones\" */\n.status-container {\n  position: relative;\n}\n\n.gestionando-inversiones {\n  display: block;\n  margin-top: 5px; /* Ajusta la distancia entre \"Activo\" y \"Gestionando Inversiones\" */\n  color: #848484;\n  font-size: 12.6px;\n  text-align: center;\n}\n\n.pdatas {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: stretch;\n}\n\n.dataTransferencia {\n  background: #ededed;\n  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 15px;\n  padding: 0px 0px 50px 40px;\n}\n\n.pdata1,\n.pdata2,\n.pdata3 {\n  width: 33%;\n  display: flex !important;\n  justify-content: center;\n  align-items: space-around;\n  flex-wrap: wrap;\n  padding: 4px;\n  text-align: center;\n}\n\n.pdata1,\n.pdata2 {\n  border-right: 1px solid gray;\n}\n\n.pdata1 {\n  padding-left: 0;\n}\n\n.pdata3 {\n  padding-right: 0;\n}\n\n.modalDetail1 .modal-content1 {\n  background-color: #181b25;\n}\n\n.modalDetail1 .modal-content1 > * {\n  width: 80%;\n  margin: 0 auto;\n}\n\n.modal-header {\n  border-bottom: 2px solid #f09502;\n}\n\n.card .containerButtons {\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  align-items: stretch;\n  margin-top: 12px; /* 20px (del gap) + 12px = 32px exactos */\n  margin-bottom: 0; /* Quitar el auto margin para respetar los gaps exactos */\n}\n\n.card .containerButtons button {\n  width: 48%;\n  margin-bottom: 0 !important;\n}\n\n/* Cuando el botón tiene la clase w-100, asegurarse que ocupe todo el ancho */\n.card .containerButtons button.w-100 {\n  width: 100% !important;\n}\n\n.buyform {\n  margin: 10px 10px 35px 80px;\n}\n\n.buyform .cost {\n  background-color: #0d0d0d;\n  padding: 15px;\n  font-size: 1rem;\n}\n\n.buyform button {\n  min-width: 60%;\n  background-color: #0d0d0e !important;\n  color: white;\n}\n\n.dataSale {\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n  align-items: stretch;\n  flex-wrap: wrap;\n}\n\n.dataSale > div {\n  border: 1px solid #f09502;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.dataSale .logoPolyscan {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  border: 1px solid;\n  padding: 8px;\n  margin-right: auto;\n  min-width: 70%;\n}\n\n.dataSale .logoPolyscan:hover {\n  cursor: pointer;\n}\n\n.dataSale .logoPolyscan img {\n  max-width: 40px;\n  height: auto;\n  margin-right: 5px;\n}\n\n.dataSale .email {\n  min-width: 70%;\n}\n\n.dataSale > div:first-child {\n  width: 40%;\n}\n\n.dataSale > div span {\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.dataSale > div:last-child {\n  width: 59%;\n}\n\n.dataSale .title {\n  font-size: 1.3rem;\n  margin-bottom: 18px;\n  font-weight: bold;\n  color: #f09502;\n}\n\n.dataSale > div:first-child p:last-child {\n  margin-bottom: 0 !important;\n}\n\n.dataSale a {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  text-decoration: none;\n}\n\n.dataDisplay {\n  display: flex;\n  gap: 60px;\n  margin-top: 2rem;\n}\n\n\n@media (max-width: 1400px) {\n  .navMargin {\n    margin-top: 3rem !important;\n  }\n\n  .cardContainer {\n    margin-top: 1rem !important;\n  }\n\n  .sizeTitle {\n    font-size: 15px !important;\n  }\n}\n\n@media (max-width: 1235px) {\n  .popularBlockchain {\n    padding: 0 !important;\n    top: -40px !important;\n    left: calc(50% - 60px) !important;\n  }\n}\n\n@media (max-width: 995px) {\n  .popularBlockchain {\n    padding: 2px 10px 0px 10px !important;\n    top: -22px !important;\n    left: calc(50% - 68px) !important;\n  }\n\n  .infoCardModal {\n    display: none !important;\n  }\n\n  .cardImageModal {\n    border: none !important;\n    padding: 10px 15px 10px 15px;\n    background-color: transparent !important;\n  }\n\n  .cardImageContainerModal {\n    border-radius: 0px !important;\n  }\n}\n\n@media (max-width: 820px) {\n  .popularBlockchain {\n    padding: 0 !important;\n    left: calc(50% - 60px) !important;\n  }\n}\n\n@media (max-width: 720px) {\n  .popularBlockchain {\n    top: -40px !important;\n  }\n}\n\n@media (max-width: 656px) {\n  .buyform {\n    margin: 20px !important;\n    margin-left: calc(15% - 30px) !important;\n  }\n\n  .cardContainer {\n    margin-top: 2rem !important;\n    padding-left: 10px !important;\n    padding-right: 0 !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .circle {\n    display: none;\n  }\n\n  .modalDetail .modal-content > *,\n  .modalDetail2 .modal-content > * {\n    width: 103%;\n  }\n\n  .buyform button {\n    width: 100%;\n  }\n\n  .pdata1,\n  .pdata2,\n  .pdata3 {\n    padding: 5px;\n  }\n\n  .pdata1 p:first-child,\n  .pdata2 p:first-child,\n  .pdata3 p:first-child {\n    font-size: 0.7rem;\n  }\n\n  .dataSale > div:first-child {\n    width: 100%;\n    padding: 0 !important;\n    margin-bottom: 35px;\n    padding-bottom: 35px !important;\n    border-bottom: 1px solid #8282828f !important;\n  }\n\n  .dataSale > div:last-child {\n    width: 100%;\n    padding: 0 !important;\n    border: none;\n  }\n\n  .priceData {\n    flex-direction: column;\n    margin: 2rem !important;\n  }\n\n  .containerBox {\n    flex-direction: column;\n    /*gap: 20px;*/\n  }\n\n  .specialBox {\n    margin-top: 1rem !important;\n  }\n\n  .titulo-movil {\n    font-size: 1rem !important;\n    margin-top: 1rem;\n  }\n\n  .movil-nav {\n    margin-top: -2rem !important;\n  }\n\n  .movil-options {\n    margin-top: -1rem !important;\n  }\n\n  .nav {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .navMargin {\n    margin: 0 !important;\n  }\n\n  .dataTransferencia {\n    padding: 0px 0px 50px 20px;\n  }\n\n  .box {\n    flex-basis: 100% !important;\n    /* Las cajas ocuparán todo el ancho en pantallas más pequeñas */\n    max-width: 100% !important;\n    /* Límite de ancho máximo de las cajas */\n  }\n\n  .terms {\n    margin-left: 0 !important;\n  }\n\n  .buttonflex {\n    margin-left: 0 !important;\n  }\n\n  .marginCantitad {\n    margin-left: 0 !important;\n  }\n\n  .popularBlockchain {\n    padding: 2px 10px 0px 10px !important;\n    top: -22px !important;\n    left: calc(50% - 68px) !important;\n  }\n\n  select {\n    margin-bottom: 10px;\n  }\n\n  .dataTransferencia {\n    padding: 0px 0px 50px 5px;\n  }\n\n  .iban {\n    padding-top: 23px;\n  }\n\n  .dataDisplay {\n    gap: 20px;\n  }\n\n  .form-control {\n    font-size: 11px;\n  }\n\n  .cardImageContainerModal {\n    width: 100%;\n    padding-bottom: 0 !important;\n    background-color: #ffffff !important; /* Blanco */\n    border: 1px solid #e0e0e0 !important; /* Borde delgado gris */\n    margin-bottom: 30px;\n    border-radius: 18px !important; /* Bordes más redondeados */\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important; /* Sombra ligera */\n  }\n\n  .no-mobile {\n    display: none !important;\n  }\n\n  h5 {\n    font-size: 0.85rem !important;\n  }\n\n  .popular {\n    left: calc(50% - 50px) !important;\n  }\n}\n\n@media (min-width: 656px) {\n  .options-mobile {\n    display: none;\n  }\n}\n\n.flexContainer {\n  display: flex;\n}\n\n.colorDark {\n  background-color: #181b25;\n}\n\n.colorWhite {\n  background-color: white;\n}\n\n.paddingModalBody {\n  padding: 0 !important;\n}\n\n.cardContainer {\n  margin-top: 4rem;\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n\n.btnClose {\n  background-color: transparent;\n  color: white;\n  border: none;\n  font-size: 15px;\n}\n\n.btnContainer {\n  margin-top: 2rem;\n}\n\nmdb-tab {\n  color: black !important;\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n  color: #ff9600;\n  border: none;\n  border-bottom: 1px solid;\n}\n\n.nav-link {\n  color: black;\n  border: none;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.dai {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.iQuestion {\n  color: gray;\n  font-size: 24px;\n  margin-top: -4px;\n}\n\np,\nlabel {\n  color: #848484;\n}\n\n.marginCantitad {\n  display: flex;\n  gap: 15px;\n  margin-left: -2.3rem;\n}\n\n.priceData {\n  display: flex;\n  justify-content: space-between;\n  margin: 10px 120px 10px 85px;\n}\n\n.containerBox {\n  display: flex;\n  flex-wrap: wrap;\n  /* Permite que los elementos se envuelvan cuando no haya suficiente espacio en una línea */\n}\n\n.box {\n  border: 3px solid #ff9600;\n  padding: 5px 5px 5px 5px;\n  margin-right: 15px;\n  margin-bottom: 15px;\n  cursor: pointer;\n  border-radius: 20px;\n  max-width: 250px;\n  position: relative;\n  flex: 1;\n}\n\n.box.active {\n  background-color: rgba(255, 150, 0, 0.2);\n}\n\n.popular {\n  position: absolute;\n  border: 3px solid #ff9600;\n  background: white;\n  border-radius: 25px;\n  padding: 2px 10px 0px 10px;\n  top: -24px;\n  left: calc(50% - 68px);\n}\n\n.divPersonalizar {\n  display: flex;\n  align-items: center;\n}\n\n.personalizar {\n  color: black;\n  text-decoration: underline;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.form-control:focus {\n  outline-color: #ff9600;\n}\n\n.navMargin {\n  margin: 70px 10px 30px 80px;\n  margin-top: 7rem;\n}\n\n.tool {\n  cursor: help;\n  position: relative;\n}\n\n.tool::before,\n.tool::after {\n  top: 50%;\n  opacity: 0;\n  position: absolute;\n  z-index: -100;\n}\n\n.tool:hover::before,\n.tool:focus::before,\n.tool:hover::after,\n.tool:focus::after {\n  opacity: 1;\n  transform: scale(1) translateX(0);\n  z-index: 100;\n  margin-left: 1rem;\n}\n\n.tool:hover::before,\n.tool:focus::before {\n  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26) 0.2s;\n}\n\n.tool::after {\n  background: #3e474f;\n  border-radius: 0.25em;\n  color: #edeff0;\n  content: attr(data-tip);\n  margin-top: -2.5em;\n  padding: 1em;\n  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26) 0.2s;\n  transform: scale(0.6) translateX(50%);\n  width: 20em;\n}\n\n.tool:hover::after,\n.tool:focus::after {\n  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26);\n}\n\n@media (max-width: 1060px) {\n  .tool::after {\n    font-size: 0.95em;\n    margin-top: -15.5em;\n    width: 28em;\n    right: 27%;\n    margin-top: -2px;\n    transform: translate(-50%, -50%);\n  }\n}\n\n@media (max-width: 760px) {\n  .tool::after {\n    font-size: 0.75em;\n  }\n}\n\n/*tooltip Box*/\n.con-tooltip {\n  position: relative;\n  display: inline-block;\n  cursor: help;\n}\n\n/*tooltip */\n.tooltip {\n  visibility: hidden;\n  z-index: 1;\n  position: absolute;\n  top: -140%;\n  left: -25%;\n  background: #3e474f;\n  border-radius: 0.25em;\n  color: #edeff0;\n  padding: 1em;\n  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26) 0.2s;\n  transform: scale(0.6) translateX(50%);\n  width: 20em;\n}\n\n.con-tooltip:hover .tooltip {\n  visibility: visible;\n  transform: translateY(-10px);\n  opacity: 1;\n}\n\n.right .tooltip {\n  top: 150%;\n  left: -800%;\n}\n\n.right .tooltip::after {\n  top: 150%;\n  left: -800%;\n  transform: rotate(90deg);\n}\n\n.card {\n  position: relative;\n  border-radius: 24px; /* Cambiado a 24px según Figma general */\n  width: 100%;\n  margin: 0 auto; /* Centrar dentro del col-lg-4 */\n}\n\n/* --- Botón Favoritos (Corazón) --- */\n.favorite-btn {\n  position: absolute;\n  top: 26px;\n  right: 26px;\n  display: flex !important;\n  width: 28px !important;\n  height: 28px !important;\n  padding: 0 !important;\n  justify-content: center !important;\n  align-items: center !important;\n  border-radius: 50% !important;\n  border: 1px solid rgba(255, 193, 91, 0.25) !important;\n  background: #FFF !important;\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.40) !important;\n  cursor: pointer;\n  z-index: 10;\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.favorite-btn i {\n  color: #ff8c00; /* Naranja Domoblock */\n  font-size: 16px !important;\n  width: 16px !important;\n  height: 16px !important;\n  line-height: 1 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  transform: none;\n  transition:\n    transform 0.2s ease,\n    color 0.2s ease;\n}\n\n/* Hover effect */\n.favorite-btn:hover {\n  transform: scale(1.05);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);\n}\n\n.favorite-btn:hover i {\n  transform: scale(1.1);\n}\n\n/* Estado activo (cuando ya es favorito) */\n.favorite-btn.is-active i {\n  color: #ff8c00;\n}\n/* --------------------------------- */\n.circle {\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  background: #292929;\n  color: white;\n}\n\n.terms {\n  display: flex;\n  gap: 10px;\n  margin-left: -2.2rem;\n}\n\n.buttonflex {\n  display: flex;\n  gap: 10px;\n  margin-left: -2.2rem;\n  margin-top: 1rem;\n  align-items: center;\n}\n\n.popularBlockchain {\n  position: absolute;\n  border: 3px solid #ff9600;\n  background: white;\n  border-radius: 25px;\n  padding: 2px 10px 0px 10px;\n  top: -22px;\n  left: calc(50% - 68px);\n}\n\n.sizeTitle {\n  font-weight: 600;\n}\n\nselect {\n  border: 1px solid white !important;\n}\n\n@media screen and (max-width: 600px) {\n  #amountBuyTransferencia::placeholder {\n    font-size: 9px;\n  }\n}\n\n.header-modal-wallet {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  background: #ff9600;\n  font-size: 19px;\n  color: white;\n  border-radius: 50px;\n  padding: 8px;\n}\n\n/* Ocultar la wallet completa en dispositivos móviles */\n@media (max-width: 768px) {\n  .full-wallet {\n    display: none;\n  }\n  .short-wallet {\n    display: inline;\n  }\n  .header-modal-wallet {\n    font-size: 13px;\n  }\n}\n\n/* Mostrar la wallet completa en dispositivos de escritorio */\n@media (min-width: 769px) {\n  .full-wallet {\n    display: inline;\n  }\n  .short-wallet {\n    display: none;\n  }\n}\n\n@media (max-width: 1450px) and (min-width: 500px) {\n  .small-text {\n    font-size: 0.85rem !important; /* Ajusta el tamaño según tus necesidades */\n  }\n}\n\n.progress {\n  height: 18px; /* Un poco más de altura para que el texto respire */\n  border-radius: 20px;\n  background-color: #e2e2e2;\n  box-shadow: none;\n  overflow: hidden; /* Asegura que la barra verde no se salga por las esquinas */\n}\n\n.progress-bar {\n  background: linear-gradient(90deg, #56a652 0%, #7ebc8c 100%) !important;\n  border-radius: 20px;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important; /* Centrar el texto en la parte verde */\n  font-size: 11px;\n  font-weight: 700;\n  color: white;\n  white-space: nowrap; /* Evitar saltos de línea */\n}\n\n/* Nuevos estilos para el diseño actualizado de la tarjeta (layout anibaldev) */\n.project-header {\n  width: 100%;\n}\n\n.project-title {\n  font-size: 19px !important; /* Adjusted slightly to fit the Hug dimension */\n  font-weight: 600 !important;\n  color: #000 !important;\n  margin: 0 0 10px 0 !important;\n  line-height: 23px !important;\n  width: 100% !important;\n  word-break: break-word;\n}\n\n.card .card-body .project-title,\n.card .project-header .project-title,\n.card .project-header h2.project-title,\n.card-body .project-header h2.project-title {\n  font-size: 19px !important;\n  font-weight: 600 !important;\n  line-height: 23px !important;\n}\n\n.project-address {\n  font-size: 0.95rem;\n  color: #000;\n  margin: 0;\n  line-height: 1.3 !important;\n  align-items: center !important;\n  min-width: 0;\n  flex-wrap: nowrap;\n}\n\n.project-address span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  flex: 1;\n}\n\n.project-address .fa-map-marker-alt {\n  margin-top: 0;\n  flex-shrink: 0;\n}\n\n.project-badges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n\n.badge-pill {\n  display: flex !important;\n  padding: 4px 8px !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 10px !important;\n  border-radius: 30px !important;\n  font-size: 10px !important;\n  line-height: 12px !important;\n  font-weight: 500 !important;\n  white-space: nowrap !important;\n}\n\n.badge-type {\n  background: #cdffd8;\n  color: #3b8c4c; /* Color verde oscuro sugerido para contraste */\n}\n\n.badge-code {\n  background-color: #000;\n  color: #fff;\n}\n\n.pdata-new {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end; /* Alinea los bloques por abajo */\n  margin-bottom: 8px; /* Un poco más pegado a la barra de progreso */\n  padding: 0 5px; /* Añade aire a los lados para que no estén pegados a los bordes */\n}\n\n.pdata-new > div {\n  display: flex;\n  flex-direction: column;\n}\n\n.pdata-new > .text-right {\n  align-items: flex-end; /* Fuerza los elementos hijos a alinearse a la derecha */\n}\n\n.finance-label {\n  font-family: 'Montserrat', sans-serif !important;\n  font-size: 14px; /* Aumentado tamaño */\n  color: #000000 !important;\n  margin: 0 0 2px 0; /* Menos espacio entre la etiqueta y el monto */\n  font-weight: 400 !important; /* Regular */\n  height: 15px !important;\n  line-height: 15px !important;\n}\n\n.finance-amount {\n  font-family: 'Montserrat', sans-serif !important;\n  font-size: 15px; /* Aumentado tamaño para dar mayor jerarquía */\n  font-weight: 600 !important; /* Semibold */\n  color: #000000 !important;\n  margin: 0;\n  height: 15px !important;\n  line-height: 15px !important;\n}\n\n.project-details {\n  width: 100%;\n}\n\n.detail-item {\n  font-size: 0.95rem;\n  color: #000;\n  margin: 0 0 8px 0; /* Reduce this margin if you want them tighter */\n  height: 16px !important;\n  line-height: 16px !important;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.detail-value {\n  font-weight: bold;\n  height: 15px !important;\n  line-height: 15px !important;\n  display: inline-flex;\n  align-items: center;\n}\n\n.detail-item-private {\n  color: #B0B0B0 !important;\n  font-family: 'Montserrat', sans-serif !important;\n  font-size: 0.95rem !important;\n  font-weight: 400 !important;\n  font-style: normal !important;\n  height: auto !important;\n  white-space: nowrap;\n  flex-wrap: nowrap;\n}\n\n.detail-item-private .private-label {\n  display: inline-flex;\n  align-items: center;\n}\n\n.detail-item-private .private-trailing {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.detail-item-private .badge-private-return,\n.detail-item-private .private-info-icon {\n  flex-shrink: 0;\n}\n\n@media (max-width: 600px) {\n  .detail-item-private {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: 6px;\n    padding-right: 4px;\n    font-size: 0.8rem !important;\n    white-space: nowrap;\n  }\n\n  .project-address {\n    font-size: 0.8rem !important;\n    min-width: 0;\n    align-items: center !important;\n  }\n\n  .project-address span {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    min-width: 0;\n    flex: 1;\n  }\n\n  .project-address .fa-map-marker-alt {\n    margin-top: 0;\n    font-size: 0.9rem;\n    line-height: 1;\n  }\n}\n\n.badge-private-return {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: #FFC15B40;\n  color: #D79C40;\n  padding: 2px 10px;\n  border-radius: 12px;\n  text-align: center;\n  font-family: 'Montserrat', sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: normal;\n}\n\n.badge-private-return .bi {\n  color: #D79C40;\n  font-size: 12px;\n  line-height: 1;\n}\n\n.badge-private-number {\n  display: inline-block;\n  width: 31px;\n  height: 12px;\n  color: #D79C40 !important;\n  text-align: center;\n  font-family: 'Montserrat', sans-serif !important;\n  font-size: 10px !important;\n  font-style: normal !important;\n  font-weight: 600 !important;\n  line-height: normal !important;\n  white-space: nowrap;\n}\n\n.private-info-icon {\n  color: #D79C40;\n  font-size: 1rem;\n  line-height: 1;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* Badge de estado en la imagen */\n.status-badge {\n  position: absolute;\n  top: 26px;\n  left: 26px;\n  display: inline-flex !important;\n  width: auto !important;\n  min-width: 90px !important;\n  max-width: calc(100% - 52px) !important;\n  height: 31px !important;\n  box-sizing: border-box !important;\n  padding: 8px 14px !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 10px !important;\n  border-radius: 30px !important;\n  color: #FFF !important;\n  text-align: center !important;\n  font-family: Montserrat, sans-serif !important;\n  font-size: 12px !important;\n  font-style: normal !important;\n  font-weight: 600 !important;\n  line-height: normal !important;\n  white-space: nowrap !important;\n  z-index: 10;\n}\n\n.badge-venta-privada,\n.badge-abierto {\n  background-color: #67B563 !important;\n}\n\n.badge-en-estudio {\n  background-color: #F25783 !important;\n}\n\n.badge-gestionando {\n  background-color: #67B563 !important;\n}\n\n.badge-activo {\n  background-color: #67B563 !important;\n}\n\n.badge-financiado {\n  background-color: #B084E9 !important;\n}\n\n.badge-en-curso {\n  background-color: #B084E9 !important;\n}\n\n.badge-dividendos {\n  background-color: #579AF2 !important;\n}\n\n.badge-vendido {\n  background-color: #AEB4BD !important;\n}\n\n/* --- Contador de lanzamiento (proyectos \"En estudio\") --- */\n.launch-countdown {\n  position: absolute;\n  top: 100px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 9;\n  box-sizing: border-box;\n  width: max-content;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 16px;\n  padding: 6px 18px 10px 18px;\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.12); /* #0000001F */\n  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.12);\n  font-family: Montserrat, sans-serif;\n}\n\n.countdown-unit {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 52px;\n}\n\n.countdown-value {\n  color: #fff;\n  font-size: 39px;\n  font-weight: 700;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.countdown-label {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.countdown-divider {\n  width: 1px;\n  height: 45px;\n  align-self: center;\n  background: rgba(255, 255, 255, 0.6);\n}\n\n.btn-invest {\n  background: #ff9600;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  padding: 8px 24px !important;\n  font-weight: 700;\n  font-size: 15px !important;\n  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.12);\n  transition: all 0.3s ease;\n  \n  /* Nuevas medidas de Figma */\n  display: flex !important;\n  width: 142px !important;\n  height: 34px !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 10px !important;\n  flex-shrink: 0 !important;\n  box-sizing: border-box !important;\n  white-space: nowrap !important;\n}\n\n.btn-invest:hover:not(:disabled) {\n  background: #e68700;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(255, 150, 0, 0.3);\n}\n\n.btn-invest:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-know-more {\n  background: white;\n  color: #ff9600;\n  border: 1px solid #ff9600;\n  border-radius: 10px;\n  padding: 8px 20px !important;\n  font-weight: 700;\n  font-size: 15px !important;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05); /* Sombra suavizada */\n  transition: all 0.3s ease;\n\n  /* Nuevas medidas de Figma */\n  display: flex !important;\n  width: 142px !important;\n  height: 34px !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 10px !important;\n  flex-shrink: 0 !important;\n  box-sizing: border-box !important;\n  white-space: nowrap !important;\n}\n\n.btn-know-more:hover:not(:disabled) {\n  background: #fff8f0;\n  color: #e68700;\n  border-color: #e68700;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.btn-know-more:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.card .containerButtons {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.card .containerButtons .btn {\n  flex: 1;\n  margin-bottom: 0 !important;\n  min-width: 0;\n}\n\n.card .containerButtons .btn.w-100 {\n  flex: 1 1 100%;\n}\n\n/* =========================================================================\n   Ajustes Figma escritorio 1440 (franja 992px–1440px).\n   - >1440px: se mantiene el diseño original (card fluida, como estaba antes).\n   - 992–1440px: medidas exactas de Figma. El cap max-width:327 hace que el\n     ancho se ajuste de forma responsive según baja el viewport.\n   - <992px: responsive original de tablet/móvil.\n   ========================================================================= */\n@media (min-width: 992px) and (max-width: 1440px) {\n  /* Tarjeta: 327x580 fija, centrada en su columna */\n  .card,\n  .card.bradius {\n    max-width: 327px !important; /* ancho de tarjeta */\n    margin-left: auto !important;\n    margin-right: auto !important;\n    height: 580px !important; /* alto fijo */\n    min-height: 580px !important;\n    max-height: 580px !important;\n    align-self: flex-start !important; /* evita que el stretch del row la alargue */\n    gap: 8px; /* reduce hueco imagen<->título para que el contenido suba */\n  }\n\n  /* Imagen ocupa todo el ancho de la tarjeta */\n  .card .containerImg {\n    width: 100% !important;\n    align-self: stretch !important;\n  }\n\n  /* Reduce padding sup/inf para que \"Ver detalles\" no se corte en los 580px */\n  .card-body {\n    padding: 4px 20px 12px 20px;\n  }\n\n  /* Badge \"En estudio\": 90x31 con padding 8/12 */\n  .badge-en-estudio {\n    width: 90px !important;\n    min-width: 90px !important;\n    max-width: 90px !important;\n    height: 31px !important;\n    padding: 8px 12px !important;\n  }\n\n  /* Countdown: número 53x35.52, etiquetas alto 15 con anchos por palabra */\n  .countdown-unit {\n    width: 53px;\n  }\n\n  .countdown-value {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 53px;\n    height: 35.52px;\n    font-size: 35.52px; /* line-height:1 -> caja de texto = 35.52px */\n  }\n\n  .countdown-label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 15px;\n    font-size: 15px;\n  }\n\n  .countdown-label--dia {\n    width: 47px;\n  }\n\n  .countdown-label--hora {\n    width: 50px;\n  }\n\n  .countdown-label--minuto {\n    width: 50px;\n  }\n\n  /* Título 192x23 (alto ya viene de line-height:23) */\n  .project-title {\n    width: 192px !important;\n  }\n\n  /* Dirección 211x17 */\n  .project-address {\n    width: 211px;\n    height: 17px;\n    line-height: 17px !important;\n  }\n\n  /* Icono de dirección 10.3x12.6 (inline-block para que apliquen width/height) */\n  .project-address .fa-map-marker-alt {\n    display: inline-block;\n    width: 10.3px;\n    height: 12.6px;\n    font-size: 12.6px;\n  }\n\n  /* Badges: se mantiene el estilo base (hug + padding 4px 8px = Figma).\n     Solo aumentamos la separación entre las dos badges a 20px. */\n  .project-badges {\n    gap: 20px;\n  }\n\n  /* Financiado/Objetivo: etiquetas y valores 116.8x15 (alto ya viene de line-height:15) */\n  .finance-label,\n  .finance-amount {\n    width: 116.8px;\n  }\n\n  /* Columna Objetivo: alinear texto a la derecha dentro de su caja de 116.8px */\n  .text-right .finance-label,\n  .text-right .finance-amount {\n    text-align: right;\n  }\n\n  /* Barra de progreso 238.9x14 */\n  .progress {\n    width: 238.9px;\n    height: 14px;\n  }\n\n  /* Rentabilidad Venta Privada: evitar que el icono \"i\" (tooltip) se corte.\n     Se reduce un poco la fuente de esta fila para que la etiqueta entre\n     completa (sin …) y el badge + icono queden dentro de la tarjeta (327px). */\n  .detail-item-private {\n    font-size: 0.9rem !important; /* casi igual que las demás filas (0.95rem) */\n    gap: 2px; /* reduce el espacio después del \":\" */\n  }\n\n  /* Badge un poco más compacto para liberar espacio a la derecha */\n  .detail-item-private .private-trailing {\n    gap: 4px;\n  }\n\n  .detail-item-private .badge-private-return {\n    padding: 2px 6px;\n    gap: 3px;\n  }\n\n  /* La etiqueta se ajusta a su texto (no crece): así el badge queda pegado al \":\" */\n  .detail-item-private .private-label {\n    display: block;\n    flex: 0 1 auto;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis; /* fallback por si el texto fuese más largo */\n    white-space: nowrap;\n  }\n}\n\n/* =========================================================================\n   Ajustes mobile (<992px)\n   ========================================================================= */\n@media (max-width: 991.98px) {\n  /* Tarjeta mobile: frame Figma 384x621. El alto 621 ya viene de min-height\n     en la base; aquí acotamos el ancho a 384px (max-width para que en\n     pantallas más angostas se ajuste) y la centramos. */\n  .card,\n  .card.bradius {\n    max-width: 384px !important;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n\n  /* Countdown: alto del número 35.52px (line-height:1 -> caja = font-size) */\n  .countdown-value {\n    font-size: 35.52px;\n  }\n\n  /* Badge \"En estudio\" según Figma: texto 16px/600 + padding 8px 12px.\n     El \"88x20\" de Figma es el frame del TEXTO; la badge = texto + padding,\n     por eso se ajusta al contenido (width/height auto) para que el texto\n     entre con su espaciado correcto (queda ~112x36). */\n  .badge-en-estudio {\n    width: auto !important;\n    min-width: 0 !important;\n    max-width: none !important;\n    height: auto !important;\n    padding: 8px 12px !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    line-height: normal !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
